import { ReactNode } from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { Theme } from '@mui/material/styles';

import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

type FormErrorMessageProps = {
  children: ReactNode;
} & React.ComponentProps<typeof FormHelperText>;

const FormErrorMessage = ({ children, ...props }: FormErrorMessageProps) => {
  return (
    <Stack component="span" direction="row" alignItems="center" {...props}>
      <Typography
        variant="error.inline"
        sx={(theme: Theme) => ({
          display: 'inline-flex',
          alignItems: 'center',
          gap: '3px',
          letterSpacing: '0%',
          // CPQ Branding -> Borders & Feedback -> "Error Colour" (novus.errorRed).
          // This used the ui-kit's statusColors.venetianRed, which CPQ Branding does
          // not expose, so field-level validation messages were the one error surface
          // a tenant could not theme. novus.errorRed defaults to the same #cf1010, so
          // an un-themed storefront is unchanged.
          color: theme.novus.errorRed,
        })}
      >
        <Stack component="span" fontSize="20px">
          <WarningAmberRoundedIcon fontSize="inherit" color="inherit" />
        </Stack>
        {children}
      </Typography>
    </Stack>
  );
};

export default FormErrorMessage;
